const {Vector3, Quaternion} = THREE;
import {transformPoint, getCentroid, getWorldPosition, setQuaternionFromDirection} from './utils.js';

const Z_AXIS = new Vector3(0, 0, 1);
const {DEG2RAD, RAD2DEG} = THREE.MathUtils;

/**
 * A class for a constraint.
 */
class IKHingeConstraint {
    /**
     * Pass in an angle value in degrees.
     *
     * @param {number} angle
     * @param {Vector3} hingeNormal
     */
    constructor(angle, hingeAxis) {
        this.isHinge = true;
        this.angle = angle;
        this.hingeAxis = hingeAxis.clone().normalize();
    }

    /**
     * Applies a constraint to passed in IKJoint, updating
     * its direction if necessary. Returns a boolean indicating
     * if the constraint was applied or not.
     *
     * @param {IKJoint} joint
     * @private
     * @return {boolean}
     */
    _apply(joint) {

        if (joint.disabled) {
            return false;
        }

        // Get direction of joint and parent in world space
        const direction = new Vector3().copy(joint._getDirection());
        const parentDirection = joint._localToWorldDirection(new Vector3().copy(joint._originalDirection)).normalize();
        const hingeNormal = joint._localToWorldDirection(new Vector3().copy(this.hingeAxis)).normalize();

        const offset = direction.clone().projectOnVector(hingeNormal);

        let result = false;

        if (offset.length() > 1e-7) {
            direction.projectOnPlane(hingeNormal);
            direction.normalize();
            joint._setDirection(direction);
            result = true;
        }

        // Find the current angle between them
        const currentAngle = direction.angleTo(parentDirection) * RAD2DEG;

        if ((this.angle / 2) < currentAngle) {
            direction.normalize();
            // Find the correction axis and rotate around that point to the
            // largest allowed angle
            const correctionAxis = new Vector3().crossVectors(parentDirection, direction).normalize();

            parentDirection.applyAxisAngle(correctionAxis, this.angle * DEG2RAD * 0.5);
            joint._setDirection(parentDirection);
            result = true;
        }

        return result;
    }
}

export default IKHingeConstraint;
